import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef, useCallback } from 'react';
import classNames from 'classnames';
import { SvgUpload } from '../../icons/upload';
import { SecondaryBtn } from '../btn/SecondaryBtn';
import { Icon, SIZE } from '../icon/Icon';
import './UploadDropZone.scss';
export const UploadDropZone = ({ label, btnLabel, isDisabled, isShown, name, children, onDrop, }) => {
    const inputRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const dragOverTimeout = useRef(0);
    const handleDrop = useCallback((e) => {
        if (e.target !== inputRef.current) {
            e.preventDefault();
        }
        setIsDragging(false);
    }, []);
    const handleDragOver = useCallback((e) => {
        if (e.target !== inputRef.current) {
            e.preventDefault();
        }
        setIsDragging(true);
        dragOverTimeout.current && window.clearTimeout(dragOverTimeout.current);
        dragOverTimeout.current = window.setTimeout(() => {
            setIsDragging(false);
        }, 250);
    }, [dragOverTimeout]);
    useEffect(() => {
        document.addEventListener('drop', handleDrop);
        document.addEventListener('dragover', handleDragOver);
        return () => {
            document.removeEventListener('drop', handleDrop);
            document.removeEventListener('dragover', handleDragOver);
        };
    }, [handleDrop, handleDragOver]);
    return (_jsxs("div", { className: classNames({
            'sg-uploadDropZone': true,
            'sg-uploadDropZone-isDragging': isDragging,
            'sg-uploadDropZone-isDisabled': isDisabled,
            'sg-uploadDropZone-isShown': isShown,
        }), children: [_jsx("div", { className: 'sg-uploadDropZone--inner', children: children }), _jsx("input", { ref: inputRef, className: 'sg-uploadDropZone--input', multiple: true, type: 'file', name: name, title: '', disabled: isDisabled, onChange: onDrop }), _jsxs("figure", { className: 'sg-uploadDropZone--figure sg-u-vs-1', children: [_jsx(Icon, { element: _jsx(SvgUpload, {}), size: SIZE.MED }), label && _jsx("figcaption", { children: label }), btnLabel && _jsx(SecondaryBtn, { onClick: console.log, children: btnLabel })] })] }));
};
//# sourceMappingURL=UploadDropZone.js.map